import { interpret, ErrorPlatformEvent } from 'xstate-v4'
import {
  reportApiError,
  reportAppError,
} from '~/utility/sentry/apiErrorReporter'
import { DatepickerAvailabilityServiceFetch } from './DatepickerAvailabilityServiceFetch'
import { returnDatepickerAvailabilityMachine } from './machine'

export function getDatepickerAvailabilityMachine(langCode: string) {
  return interpret(
    returnDatepickerAvailabilityMachine().withConfig({
      services: {
        fetch: async ({ fetchingParams: { slug, categories, pitchtypeId } }) =>
          await new DatepickerAvailabilityServiceFetch().get(
            langCode,
            slug,
            categories,
            pitchtypeId,
          ),
      },
      actions: {
        logError: (_, _event: any) => {
          const event: ErrorPlatformEvent = _event
          const error = event.data

          // Use structured Sentry reporting for API errors
          if (
            error.name === 'DatepickerFetchError' ||
            error.name === 'DatepickerValidationError'
          ) {
            reportApiError(error, 'datepicker availability state machine', {
              stateMachineEvent: event.type,
              stateMachineName: 'datepickerAvailabilityMachine',
            })
          } else {
            // Handle unexpected errors
            reportAppError(error, 'datepicker availability state machine', {
              stateMachineEvent: event.type,
              stateMachineName: 'datepickerAvailabilityMachine',
              errorName: error.name || 'UnknownError',
            })
          }
        },
      },
    }),
  )
}
